"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	serialize: function serialize(description) {
		return btoa(description.sdp);
	},
	deserialize: function deserialize(token, type) {
		return { type: type, sdp: atob(token) };
	}
};